var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('NavBar'),(_vm.show)?_c('v-main',[_c('registration-banner'),_c('router-view')],1):_c('v-main',[_c('v-container',[_vm._v(" Caricamento in corso... ")])],1),_c('BottomBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }